export default "__VITE_ASSET__BODEQnDa__"